/**
 * Client-side RBAC helpers — mirrors Dashboard permission checks.
 */

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

export const createPermissionChecker = (user = getStoredUser()) => {
  const roleCodes = Array.isArray(user.role_codes)
    ? user.role_codes.map((x) => String(x).toUpperCase())
    : [];
  const userRole = (user.role || roleCodes[0] || '').toUpperCase();
  const userPermissionKeys = Array.isArray(user.permissions) ? user.permissions : null;
  const hasPermissionPayload = Array.isArray(user.permissions);
  const userPermissionSet = new Set((userPermissionKeys || []).map((x) => String(x)));
  const isPrivilegedUser = roleCodes.includes('SUPER_ADMIN')
    || roleCodes.includes('ADMIN')
    || userRole === 'SUPER_ADMIN'
    || userRole === 'ADMIN';

  const hasPermission = (moduleKey, actionKey) => {
    if (isPrivilegedUser) return true;
    if (!hasPermissionPayload) return true;
    const mk = String(moduleKey || '');
    const ak = String(actionKey || '');
    if (
      userPermissionSet.has(`${mk}:${ak}`)
      || userPermissionSet.has(`${mk}:manage`)
      || userPermissionSet.has('*:*')
    ) {
      return true;
    }
    if (ak.startsWith('page:') && mk && mk !== 'admin_panel') {
      return ['view', 'create', 'update', 'delete'].some((a) => userPermissionSet.has(`${mk}:${a}`));
    }
    return false;
  };

  const hasExactPermission = (moduleKey, actionKey) => {
    if (isPrivilegedUser) return true;
    if (!hasPermissionPayload) return true;
    const mk = String(moduleKey || '');
    const ak = String(actionKey || '');
    return userPermissionSet.has(`${mk}:${ak}`)
      || userPermissionSet.has(`${mk}:manage`)
      || userPermissionSet.has('*:*');
  };

  return { hasPermission, hasExactPermission, isPrivilegedUser, hasPermissionPayload };
};

export const { hasPermission } = createPermissionChecker();
